import styled, { css } from 'styled-components'
import Paper from '@material-ui/core/Paper'
import { theme } from '../../../theme/Global'

export const CurrentNumber = styled.div`
  color: ${theme.colors.redText};
  text-decoration: none;
  width: 100%;
  text-align: center;
  font-size: 50px;
  font-weight: 600;
  cursor: pointer;
`

export const LocationsLabel = styled.h3`
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  color: ${theme.colors.redText};
  text-align: center;
  margin-top: 2.25rem;
  margin-bottom: 2.50rem;
`

export const SelectRange = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`

export const StateListWrapper = styled.div`
  width: 80%;
  margin: 0 auto;
  text-align: center;
`

export const NotificationsErrorMessage = styled.div`
  & {${css(CurrentNumber)}}
`

export const WageNotificationsContainer = styled(Paper)`
  box-shadow: unset;
  padding-top: 1.75rem;
  padding-bottom: 3rem;
`

export const NextDaysText = styled.div`
  font-weight: 600;
  text-align: center;
  color: ${theme.colors.darkBlueText};
`
